import React from 'react';
import Weather from './components/weather';

const App = () => {
  return (
    <React.Fragment>
      <Weather />
    </React.Fragment>
  );
}

export default App;
